import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axios";
import { GET_STERLING_WALLET_URL, TRANSFER_STERLING_URL } from "../../api/urls";

export const getWalletBalance = createAsyncThunk("wallet/getWalletBalance", async (user, { rejectWithValue }) => {
  try {
    const result = await api.get(`/wallet/${user.id}/balance`);
    return result.data;
  } catch (error) {
    return rejectWithValue(error.message || "Error fetching data");
  }
});

export const getWalletActivity = createAsyncThunk("wallet/getWalletActivity", async ({ user, pageSize, currentPage, activeView }, { rejectWithValue }) => {
  try {
    const result = await api.get(`/wallet/${user.id}/walletactivity?pageSize=${pageSize}&currentPage=${currentPage}&type=${activeView}`);
    return result.data;
  } catch (error) {
    return rejectWithValue(error.message || "Error fetching data");
  }
});

export const getSterlingWallet = createAsyncThunk("wallet/getSterlingWallet", async (user, { rejectWithValue }) => {
  try {
    const result = await api.get(`/wallet/${user.id}${GET_STERLING_WALLET_URL}`);
    return result.data;
  } catch (error) {
    return rejectWithValue(error.message || "Error fetching data");
  }
});

export const transferSterlingFunds = createAsyncThunk("wallet/transferSterlingFunds", async ({ user, ...payload }, { rejectWithValue }) => {
  try {
    const result = await api.post(TRANSFER_STERLING_URL, { userId: user.id, ...payload });
    return result.data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.error || error?.response?.data?.message || "Transfer failed");
  }
});

export const getReferralActivity = createAsyncThunk(
    "wallet/getReferralActivity",
    async ({ user, pageSize, currentPage },
           { rejectWithValue }) => {
  try {
    const result = await api.get(`/wallet/${user.id}/referralactivity?
    pageSize=${pageSize}&currentPage=${currentPage}`);
    return result.data;
  } catch (error) {
    return rejectWithValue(error.message || "Error fetching data");
  }
});

